import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import OrderItem from "../UserOrderItem";
import styles from "./userorderlist.module.css";
import { useTranslation } from "react-i18next";
const orders = [
  {
    brand: "Adidas",
    item: "Áo thể thao nam",
    variation: "Size 38",
    quantity: 1,
    price: "429.000",
    status: "HOÀN THÀNH",
    deliveryStatus: "Giao hàng thành công",
  },
  {
    brand: "Nike",
    item: "Quần thể thao nam",
    variation: "Size 48",
    quantity: 2,
    price: "429.000",
    status: "ĐÃ HỦY",
    deliveryStatus: "",
  },
];

const OrderList = () => {
  const { t } = useTranslation();
  const [searchTerm, setSearchTerm] = useState("");

  const filteredOrders = orders.filter(
    (order) =>
      order.brand.toLowerCase().includes(searchTerm.toLowerCase()) ||
      order.item.toLowerCase().includes(searchTerm.toLowerCase())
  );
  return (
    <div className={styles.orderList}>
      <TextField
        placeholder={t("find_order")}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
        variant="outlined"
        fullWidth
        className={styles.searchBar}
        sx={{ backgroundColor: "white" }}
      />
      {filteredOrders.length > 0 ? (
        filteredOrders.map((order, index) => (
          <OrderItem key={index} {...order} />
        ))
      ) : (
        <p>{t("no_order_found")}</p>
      )}
    </div>
  );
};

export default OrderList;
